export * from './post-objekt.service';
export * from './post-objekt.service.module';